    import {
        Modal,
        message
    } from 'ant-design-vue'
    import {
        createVNode
    } from 'vue'
    import {
        ExclamationCircleOutlined
    } from '@ant-design/icons-vue'
    import store from '../store/index'
    import {
        searchById
    } from '@/api/common/public'
import { color } from 'echarts'
    export default {
        getMenuArrayParent(arr, id) {
            var temp = []
            var forFn = function (list, id) {
                for (var i = 0; i < list.length; i++) {
                    var item = list[i]
                    if (item.id == id) {
                        temp.unshift(item)
                        forFn(arr, item.pid)
                        break
                    } else {
                        if (item.children) {
                            forFn(item.children, id)
                        }
                    }
                }
            }
            forFn(arr, id)
            return temp
        },
        getAuthority(name) {
            let operation = store.state.operation[name]
            if (operation) {
                sessionStorage.removeItem('operation')
                return operation
            }
            return {}
        },
        getSessionStorage(name) {
            let operation = sessionStorage.getItem(name)
            return operation
        },
        message(type, str) {
            return message[type](str)
        },
        getToken() {
            return localStorage.getItem('token')
        },
        removeToken() {
            return localStorage.removeItem('token')
        },
        /**
         * 获取url 参数
         */
        get_query() {
            let query = {};
            let search = location.search
            if (search.length > 2) {
                search = search.split('?')[1].split('&')
                for (let i = 0; i < search.length; i++) {
                    let arr = search[i].split('=');
                    if (arr.length == 2) {
                        query[arr[0]] = arr[1]
                    }
                }
            }
            return query
        },

        /**
         * 导出文件
         */
        exportFile(urls, name) {
            return new Promise((resolve, reject) => {
                const x = new window.XMLHttpRequest();
                x.open('GET', urls, true);
                x.responseType = 'blob';
                x.onload = () => {
                    const url = window.URL.createObjectURL(x.response);
                    const a = document.createElement('a');
                    a.href = url;
                    a.target = '_blank'
                    a.download = name;
                    a.click();
                    resolve()
                };
                x.onerror = () => {
                    reject()
                };
                x.send();
            })

        },
        // 处理链接参数
        urlParamsToObject(str) {
            let url = new URL(str)
            const params = new URLSearchParams(url.search);
            const paramObj = {};
            for (let [key, value] of params) {
                paramObj[key] = decodeURIComponent(value);
            }
            return paramObj;
        },
        // 删除方法封装
        deleteFun(data = {
            toast: true,
            cancelText: '取消',
            okText: '确定',
            type: 'confirm'
        }, api = '', where = {}) {
            data.toast = data.hasOwnProperty('toast') ? data.toast : true
            data.cancelText = data.hasOwnProperty('cancelText') ? data.cancelText : '取消'
            data.okText = data.hasOwnProperty('okText') ? data.okText : '确定'
            data.type = data.hasOwnProperty('type') && ['confirm', 'info', 'success', 'warning', 'error'].indexOf(data.type) != -1 ? data.type : 'confirm'
            return new Promise((resolve, reject) => {
                Modal[data.type]({
                    content: createVNode('strong', { 
                        style: { color: '#9d9d9d' } 
                      }, data.title),
                    title: createVNode('strong', { 
                        style: { fontWeight: 'bold' } 
                      }, data.content),
                      icon: createVNode(ExclamationCircleOutlined, {
                        style: {
                          color: '#ff4d4f', // 红色色值
                          fontSize: '22px',
                          marginRight: '8px'
                        }
                      }),
                    okText: data.okText,
                    onOk() {
                        if (api) {
                            api({
                                data: {
                                    id: data.id,
                                    ...where
                                },
                                toast: data.toast
                            }).then((res) => {
                                resolve(res)
                            })
                        } else {
                            resolve()
                        }
                    },
                    cancelText: data.cancelText,

                    onCancel() {
                        reject()
                    },
                });
            })

        },

        // 防抖
        // 首次运行时把定时器赋值给一个变量， 第二次执行时，
        // 如果间隔没超过定时器设定的时间则会清除掉定时器，
        // 重新设定定时器， 依次反复， 当我们停止下来时，
        // 没有执行清除定时器， 超过一定时间后触发回调函数。
        debounce(fun, delay) {
            return function (args) {
                // 获取函数的作用域和变量
                const that = this
                const _args = args
                // 每次事件被触发，都会清除当前的timeer，然后重写设置超时调用
                clearTimeout(fun.id)
                fun.id = setTimeout(function () {
                    fun.call(that, _args)
                }, delay)
            }
        },
        /**
         * 判断是否为空对象
         * @param {*} object 源对象
         */
        isEmptyObject(object) {
            return Object.keys(object).length === 0
        },
        /**
         * 判断是否为空
         * @param {*} object 源对象
         */
        isEmpty(value) {
            if (this.isArray(value)) {
                return value.length === 0
            }
            if (this.isObject(value)) {
                return this.isEmptyObject(value)
            }
            return !value
        },
        /**
         * 判断是否为对象
         * @param {*} array
         */
        isArray(array) {
            return Object.prototype.toString.call(array) === '[object Array]'
        },
        /**
         * 判断是否为对象
         * @param {*} object
         */
        isObject(object) {
            return Object.prototype.toString.call(object) === '[object Object]'
        },
        /**
         * 递归属性结构转化为扁平结构
         * @param {*} data
         * @param {*} indexArray
         * @param {*} all
         */
        findIndexArray(data, indexArray, all) {
            let arr = Array.from(indexArray);
            for (let i = 0, len = data.length; i < len; i++) {
                arr.push(data[i].name);
                let children = data[i].children;
                if (children && children.length) {
                    this.findIndexArray(children, arr, all);
                } else {
                    let joinArr = arr.join("-");
                    if (!all.includes(joinArr)) {
                        all.push(joinArr);
                    }
                }
                arr.pop();
            }
            return all;
        },
        /**
         * 判断是否在数组中
         * @param {*} search
         * @param {*} array
         */
        inArray(search, array) {
            return array.includes(search)
        },
        /***
         * 手机号校验
         */
        checkTelephone(mobile) {
            if (!mobile && mobile != 0) {
                return false
            }
            if (typeof mobile == 'number') {
                mobile = mobile.toString()
            }
            var tel = /^0\d{2,3}-?\d{7,8}$/;
            var phone = /^1[3-9]\d{9}$/;
            if (mobile.length == 11) { //手机号码
                if (phone.test(mobile)) {
                    return true;
                }
            } else if (mobile.length == 13 && mobile.indexOf("-") != -1) { //电话号码
                if (tel.test(mobile)) {
                    return true;
                }
            } else {
                return false;
            }
        },
        /**
         * 富文本替换
         */
        getWangEditorText(str) {
            return str
                .replace(/<[^<p>]+>/g, "") // 将所有<p>标签 replace ''
                .replace(/<[</p>$]+>/g, "") // 将所有</p>标签 replace ''
                .replace(/&nbsp;/gi, "") // 将所有 空格 replace ''
                .replace(/<[^<br/>]+>/g, ""); // 将所有 换行符 replace '
        },
        /**
         * 搜索
         */
        filterOption(key = 'label') {
            return (input, option) => {
                return option[key].toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
        },
        /**
         * 表单自定义校验只能包含字母，数字，下划线和破折号
         */
        validateInput(rule, value) {
            if (!value || /[^A-Za-z0-9_-]/.test(value)) {
                return Promise.reject('只能包含字母、数字和下划线_及破折号-');
            } else {
                return Promise.resolve();
            }
        },
        //门店检索
        storeSearchFun(city, keyword) {
            return new Promise((resolve, reject) => {
                if (!city || !keyword) {
                    resolve([])
                }
                try {
                    let geocoder = new BMap.Geocoder({
                        extensions_town: true
                    });
                    let suggest = new BMap.LocalSearch(city, {
                        pageCapacity: 20,
                        onSearchComplete(res) {
                            let maps = res.Wr ? res.Wr : res.qk
                            let arr = maps.map(item => {
                                return {
                                    ...item,
                                    latitude: item.point.lat,
                                    longitude: item.point.lng,
                                    name: item.title,
                                    street_id: item.uid
                                }
                            })

                            arr.forEach(item => {
                                if (item.point) {
                                    geocoder.getLocation(item.point, (data) => {
                                        item.province = data.addressComponents.province
                                        item.city = data.addressComponents.city
                                        item.area = data.addressComponents.district
                                    })
                                }
                            })
                            searchById({
                                data: {
                                    street_ids: arr.map(item => item.uid)
                                },
                                loading: false
                            }).then(data => {
                                if (data.length) {
                                    arr.forEach(item => {
                                        if (data.includes(item.uid)) {
                                            item.is_add = 1
                                        }
                                    })
                                }
                                setTimeout(() => {
                                    resolve(arr)
                                }, 2000)
                            }).catch(() => {
                                reject()
                            })
                        }
                    })
                    suggest.search(keyword, {
                        forceLocal: true,
                    })
                } catch (error) {
                    reject()
                }

            })
        },
        //正则校验替换保留n位小数,
        parseNumber(value, precision) {
            if(!precision){
                precision = 2
            }
            if (value === undefined || value === null) return '';
            const regex = new RegExp(`^\\D*(\\d*(?:\\.\\d{0,${precision}})?)?.*$`, 'g');
            return value.replace(regex, '$1');
        },
    }